import React from 'react'
import Sidenav from './components/Sidenav'
import ProductGrid from './pages/Productgrip'
import Specialadmincomp from './components/Special/Specialadmincomp'

export default function Special() {
  return (
    <> 
    
    <div className="flex  ">
       <div className="">
       <Sidenav />
       </div>
        <div className="mt-16">
            <Specialadmincomp />
        </div>
    </div>
    </>
  )
}
